import React, { Fragment } from 'react'
import Modal from 'react-modal'

import { pathOr } from 'ramda'

import './MealDetail.css'

import Close from '../../assets/img/arrow-back.png'
import CloseMobile from '../../assets/img/back_arrow_mobile.png'
import Share from '../../assets/img/share.png'
import MealCard from './components/MealCard'
import Detail from './components/Details'
import Reviews from '../../components/Reviews'
import Nutrition from './components/Nutrition'
import Ingredients from './components/Ingredients'
import FinalSteps from './components/FinalSteps'
import Social from './components/Social'
import MealDetailSkeleton from './MealDetailSkeleton'

Modal.setAppElement('#root')

class MealDetail extends React.Component {
  state = { active: false }

  componentDidMount() {
    const { match, getMealDetail } = this.props

    const productId = pathOr(null, ['params', 'productId'], match)

    getMealDetail(productId)
  }

  componentDidUpdate(prevProps) {
    const { mealId } = this.props
    if (mealId && prevProps.mealId !== mealId) {
      this.props.getMealDetail(this.props.mealId)
    }
  }

  goBack = () => {
    this.props.history.goBack()
  }

  toggleClass = () => {
    this.setState(prevState => ({
      active: !prevState.active
    }))
  }

  render() {
    const { mealDetail, mealDetailLoading } = this.props

    const toggleChefDetail = () => {}

    const isLoading = !mealDetail || mealDetailLoading

    const mealUrl =
      !isLoading && `https://www.cookunity.com/${mealDetail.urlPath}`

    return (
      <div className="cookunity__product_detail_container">
        <div className="cookunity__product_detail">
          <div className="header">
            <div className="back_button" onClick={this.goBack}>
              <img src={Close} alt="close" />
              <p>Back to Meals</p>
            </div>

            <div className="back_button mobile" onClick={this.goBack}>
              <img src={CloseMobile} alt="close" />
            </div>

            {!isLoading && (
              <div className="share_container">
                <div className="share_button" onClick={this.toggleClass}>
                  <img src={Share} alt="share" />
                  <p>Share</p>
                </div>

                {this.state.active && (
                  <Social mealUrl={mealUrl} mealName={mealDetail.name} />
                )}
              </div>
            )}
          </div>

          {isLoading ? (
            <MealDetailSkeleton />
          ) : (
            <Fragment>
              <MealCard
                mealDetail={mealDetail}
                toggleChefDetail={toggleChefDetail}
              />
              <Detail mealDetail={mealDetail} />
              <Nutrition mealDetail={mealDetail} />
              <Ingredients mealDetail={mealDetail} />
              <FinalSteps mealDetail={mealDetail} />
              {mealDetail.reviews && (
                <Reviews
                  product={mealDetail}
                  reviews={mealDetail.reviews}
                  quantity={mealDetail.reviews.length}
                  title={'Community Reviews'}
                />
              )}
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default MealDetail



// WEBPACK FOOTER //
// ./src/modules/MealDetail/MealDetail.jsx